import { useMutation } from 'react-query';
import { createRegisterResultMinute } from 'apis/registerResult';

const useMutationRegisterResultMinute = () => {
  const { mutateAsync, ...rest } = useMutation(createRegisterResultMinute);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationRegisterResultMinute;
